import { CALL_API } from 'middleware/api';
import * as types from './types';
export const getRecentInteractions = () => ({
    [CALL_API]: {
        endpoint: '/payments/suggest-contacts',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.GET_RECENT_INTERACTIONS_REQUEST,
            types.GET_RECENT_INTERACTIONS_SUCCESS,
            types.GET_RECENT_INTERACTIONS_FAILURE,
        ],
    },
});
export const getCreditAndDebt = () => ({
    [CALL_API]: {
        endpoint: '/payments/credit-and-debt',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.GET_CREDIT_AND_DEBT_REQUEST,
            types.GET_CREDIT_AND_DEBT_SUCCESS,
            types.GET_CREDIT_AND_DEBT_FAILURE,
        ],
    },
});
export const sendReminders = (body) => ({
    [CALL_API]: {
        endpoint: '/payments/send-reminders',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            types.SEND_REMINDERS_REQUEST,
            types.SEND_REMINDERS_SUCCESS,
            types.SEND_REMINDERS_FAILURE,
        ],
    },
});
